import { organizerClubStatsApi } from "../../api/api";
import { buildStatsParams } from "./courtStatsMetrics";
import useStatsData from "./useStatsData";

/**
 * Court statistics of one club for the current and the comparison range (see `useStatsData` for the
 * loading, error and out-of-order rules).
 */
export default function useCourtStats({ clubId, current, comparison, compareMode, sport, courtId }) {
  return useStatsData({
    enabled: Boolean(clubId),
    requestKey: `${clubId}|${sport}|${courtId}`,
    fetchRange: (range) => organizerClubStatsApi(clubId, buildStatsParams(range, sport, courtId)),
    current,
    comparison,
    compareMode,
  });
}
